import { render } from "./ChargerDetail.vue?vue&type=template&id=e60864c6&scoped=true"
import script from "./ChargerDetail.vue?vue&type=script&lang=js"
export * from "./ChargerDetail.vue?vue&type=script&lang=js"

import "./ChargerDetail.vue?vue&type=style&index=0&id=e60864c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60864c6"]])

export default __exports__